import {initWizard} from '../Wizard/Wizard';

const initializedWizards = new WeakSet();

export const initializeCreateTemplateWizards = root => {
    root.querySelectorAll('[data-controller="create-template-wizard"]').forEach(wizard => {
        if (initializedWizards.has(wizard)) {
            return;
        }

        initializedWizards.add(wizard);

        const nameInput    = wizard.querySelector('input[name="name"]');
        const subjectInput = wizard.querySelector('input[name="subject"]');
        const footer       = wizard.querySelector('.wizard-footer');

        const controls = initWizard(wizard, {
            validate(panel) {
                if (panel.dataset.wizardStep === 'details' && !nameInput?.value.trim()) {
                    nameInput?.focus();

                    return false;
                }

                return true;
            },

            onStepEnter(panel, index) {
                footer?.classList.toggle('hidden', index === 0);

                if (panel.dataset.wizardStep === 'details') {
                    nameInput?.focus();
                }
            },
        });

        wizard.addEventListener('card-toggled', event => {
            const card = event.detail?.card;

            if (!card) {
                return;
            }

            if (nameInput) {
                nameInput.value = card.dataset.name ?? '';
            }

            if (subjectInput) {
                subjectInput.value = card.dataset.subject ?? '';
            }

            controls.goToStep(controls.getCurrentStep() + 1);
        });
    });
};
